<template>
  <layout-main-inner
    v-loading="loading"
    :title="$route.meta.name">
    <template slot="action">
      <el-button
        type="primary"
        @click="addItem">新增机构</el-button>
    </template>
    <layout-card-wrap hasSlot>
      <template slot="form">
        <el-input
          v-model="config.vendorName"
          clearable
          placeholder="请输入机构名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="机构名称"
          min-width="150"
          prop="name"> </el-table-column>
        <el-table-column
          label="所属行业"
          min-width="100"
          prop="trade"> </el-table-column>
        <el-table-column
          label="机构地址"
          min-width="200"
          prop="trade">
          <template slot-scope="{ row }">
            {{ row.provinceName }}{{ row.cityName }}{{ row.areaName }}{{ row.address }}
          </template>
        </el-table-column>
        <el-table-column
          label="负责人手机号"
          min-width="180"
          prop="phone"> </el-table-column>
        <el-table-column
          label="员工数量"
          min-width="120"
          :formatter="row=>`${row.accountNum}/${row.accountQuota}`"
          prop="accountNum">
        </el-table-column>
        <el-table-column
          label="开通状态"
          :formatter="row=>row.status===1?'已开通':'已关闭'"
          prop="status"
          min-width="80"></el-table-column>
        <el-table-column
          label="小程序显示涉诉信息"
          :formatter="row=>row.wxappShowJudicialCase===1?'显示':'不显示'"
          prop="status"
          min-width="80"></el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          :width="100">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="updateItem(row)">编辑</el-button>
            <el-dropdown>
              <el-button
                type="text"
                style="margin-left: 10px;">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="deleteItem(row)">删除</el-dropdown-item>
                <el-dropdown-item @click.native="viewItem(row)">查看员工</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <pagination-new
        v-model="config"
        :total="total"
        :fetch="fetchList" />
    </layout-card-wrap>
    <corp-edit-modal
      ref="edit"
      @fetch="fetchList" />
    <corp-staff-modal
      ref="staff"
      @fetch="fetchList" />
  </layout-main-inner>
</template>
<script>
import Verification from '@/service/verification'
import CorpEditModal from './busi/corp-edit-modal.vue'
import CorpStaffModal from './busi/corp-staff-modal.vue'
export default {
  name: 'VerificationCorps',
  components: { CorpEditModal, CorpStaffModal },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, vendorName: '' }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    addItem() {
      this.$refs.edit.init()
    },
    updateItem(row) {
      const { id, name, phone, status, accountQuota, trade, provinceCode, cityCode, areaCode, address, wxappShowJudicialCase } = row
      this.$refs.edit.init({ id, name, phone, status, accountQuota, trade, address, area: [provinceCode, cityCode, areaCode], wxappShowJudicialCase })
    },
    deleteItem(row) {
      this.$confirm('您确定删除该核验机构?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          Verification.deleteverificationcorp({ id: row.id })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    viewItem(row) {
      this.$refs.staff.fetch({ verificationCorpId: row.id })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      Verification.getverificationcorps({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, total, records } = res.data
          if ([0].includes(result)) {
            this.total = total
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
